import { render, staticRenderFns } from "./headerC.vue?vue&type=template&id=90d56696&scoped=true&lang=pug&"
import script from "./headerC.vue?vue&type=script&lang=js&"
export * from "./headerC.vue?vue&type=script&lang=js&"
import style0 from "./headerC.vue?vue&type=style&index=0&id=90d56696&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d56696",
  null
  
)

export default component.exports